module.exports = __webpack_public_path__ + "static/media/create-campaign-view.b895ffd4.jpg";